<template>
    <div
        class="clearfix"
        :style="lineStyle"
        style="border-bottom: 1px solid #dfdfdf;"
    ></div>
</template>

<script>
    export default {
        name: "go-line",
        props: {
            color: {
                type: String,
                default: "#dfdfdf"
            }
        },
        computed: {
            lineStyle() {
                return {
                    borderBottom: `1px solid #${this.color}`,
                    height: "1px",
                    boxSizing: "borderBox"
                };
            }
        },
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/ctlVue/go-line.vue